import { useDateFilter } from '../dateFilter'
import { useGroupFilter } from '../groupFilter'
import { useVariables } from '../variables'
import getAiBlackboxContent from './getAiBlackboxContent'
import { IAiBlackboxProps, IQueryFilter } from './type'

export interface IPropsType {
  type: 'ai-blackbox-wrapper'
  contentPartNames: string[]
  isLocationPage?: boolean
  hasDateFilter?: boolean
  hasGroupFilter?: boolean
  hasSetDate?: boolean
  width?: string
  height?: string
}

const AiBlackboxWrapper = ({
  contentPartNames,
  isLocationPage = false,
  hasDateFilter = false,
  hasGroupFilter = false,
  hasSetDate = false,
}: IPropsType) => {
  const { variables } = useVariables()
  const { startDate, endDate } = useDateFilter()
  const { groupFilter, hasGroupBy } = useGroupFilter()

  let queryFilter: IQueryFilter | null = null

  if (
    (hasDateFilter && !(startDate && endDate)) ||
    (hasGroupFilter && !groupFilter)
  ) {
    return <div>Loading ...</div>
  }

  if (hasGroupFilter) {
    if (isLocationPage) {
      queryFilter = {
        isBreakdownByLocationGroup: false,
        locationIds: groupFilter?.ids,
      }
    } else {
      queryFilter = {
        isBreakdownByLocationGroup: hasGroupBy ? false : true,
        locationGroupIds: groupFilter?.ids,
        intersectedLocationGroupIds: groupFilter?.intersectedIds,
      }
    }
  }

  const setDate = hasSetDate ? variables.date?.setDate : undefined

  // Create the props to pass to children in the blackbox
  const aiBlackboxProps: IAiBlackboxProps = {
    startDate,
    endDate,
    queryFilter,
    setDate,
  }

  const contentParts = getAiBlackboxContent(contentPartNames)

  return (
    <>
      {contentParts.map((PartComponent, index: number) => {
        if (PartComponent) {
          return (
            <PartComponent
              key={`${contentPartNames[index]}-${index}`}
              {...aiBlackboxProps}
            />
          )
        }
        return null
      })}
    </>
  )
}

export default AiBlackboxWrapper
